import { render, staticRenderFns } from "./plays.vue?vue&type=template&id=644bb0c2&"
import script from "./plays.vue?vue&type=script&lang=js&"
export * from "./plays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports